import { EMcsName } from '../../utils';

const AUTH_ENDPOINT_BASE = 'v1/auth';

export const AUTH_SIGN_UP_ENDPOINT_CONF = {
  base: `${AUTH_ENDPOINT_BASE}/sign-up`,
  mcsName: EMcsName.USER,
  access: 'public',
};

export const AUTH_LOGIN_ENDPOINT_CONF = {
  base: `${AUTH_ENDPOINT_BASE}/login`,
  mcsName: EMcsName.USER,
  access: 'public',
};

export const AUTH_LOGOUT_ENDPOINT_CONF = {
  base: `${AUTH_ENDPOINT_BASE}/logout`,
  mcsName: EMcsName.USER,
  access: 'private',
};

export const AUTH_ISSUE_MCP_TOKEN_ENDPOINT_CONF = {
  base: `${AUTH_ENDPOINT_BASE}/tokens`,
  mcsName: EMcsName.USER,
  access: 'private',
};

export const AUTH_LIST_MCP_TOKENS_ENDPOINT_CONF = {
  base: `${AUTH_ENDPOINT_BASE}/tokens`,
  mcsName: EMcsName.USER,
  access: 'private',
};

// Revoke использует POST с path-параметром tokenId, который добавляется в repository
// перед вызовом — `${base}/${tokenId}/revoke`.
export const AUTH_REVOKE_MCP_TOKEN_ENDPOINT_CONF = {
  base: `${AUTH_ENDPOINT_BASE}/tokens`,
  mcsName: EMcsName.USER,
  access: 'private',
};
